export const APP_ID = 'hyve-leasing-calculator'
